import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductionCostingComponent } from 'src/app/Module/Account/CostingAndBudgeting/production-costing/production-costing.component';

const routes: Routes = [
  {
    path: 'costing',
    component: ProductionCostingComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountCostingAndBudgetingRoutingModule { }
